module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "tss-footer"
  }, [(_vm.isSupimaLanding || _vm.isActiveWearLanding || _vm.isWinterWearLanding) ? _c('div', {
    staticClass: "supima-footer d-flex justify-content-center"
  }, [_c('img', {
    attrs: {
      "src": _vm.$parent.isDesktop ? _vm.imgBaseUrl + 'supima-footer-web.jpg' : _vm.imgBaseUrl + 'supima-footer-mobile.jpg'
    }
  })]) : _c('div', {
    staticClass: "additional-footer-container"
  }, [(_vm.footerBrandText) ? _c('div', {
    staticClass: "additional-heading"
  }, [_vm._v("\n   " + _vm._s(_vm.footerBrandText) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "additional-footer-content"
  }, [_c('div', {
    staticClass: "additional-item"
  }, [_c('h3', {
    staticClass: "additional-stats"
  }, [_vm._v("Over "), _c('span', {
    staticClass: "fbold"
  }, [_vm._v("6 Million")]), _vm._v(" Happy Customers")])])])]), _vm._v(" "), (!_vm.isCodCheckoutLogin) ? _c('div', {
    style: (("" + (this.footerCollapseStyle))),
    attrs: {
      "id": "accordionside",
      "role": "tablist",
      "aria-multiselectable": "true"
    }
  }, [_c('div', [_c('div', {
    staticClass: "cusTabs accordiontabs"
  }, [(!_vm.$parent.isDesktop) ? _c('div', {
    staticClass: "card-header d-flex justify-content-center flex-column",
    attrs: {
      "role": "tab",
      "id": "headingFooter"
    }
  }, [_c('h5', {
    staticClass: "mb-0 accordianheadings"
  }, [_c('a', {
    ref: "applyFooter",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordionside",
      "href": "#collapseFooter",
      "aria-expanded": ("" + (this.footerCollapseControl.expanded)),
      "aria-controls": "collapseFooter"
    }
  }, [_c('span', [_vm._v("Know more about The Souled Store")])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    class: _vm.$parent.isDesktop ? 'show' : this.footerCollapseControl.expandedClass,
    attrs: {
      "id": "collapseFooter",
      "role": "tabpanel",
      "aria-labelledby": "headingFooter"
    }
  }, [(!_vm.$parent.isDesktop && !_vm.isBflUtm && _vm.isSelectedCountryIndia) ? _c('div', {
    staticClass: "w-100 px-2 py-4",
    staticStyle: {
      "background": "#ddd"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('a', {
    attrs: {
      "href": "https://play.google.com/store/apps/details?id=com.thesouledstore"
    },
    on: {
      "click": function($event) {
        _vm.triggerEvent('Play Store')
      }
    }
  }, [_c('img', {
    staticClass: "app-store-logo mr-2",
    attrs: {
      "data-src": "https://tss-static-images.gumlet.io/icons/play-store.png",
      "alt": "Download app on google play store"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://apps.apple.com/in/app/thesouledstore/id1493897434"
    },
    on: {
      "click": function($event) {
        _vm.triggerEvent('App Store')
      }
    }
  }, [_c('img', {
    staticClass: "app-store-logo ml-2",
    attrs: {
      "data-src": "https://tss-static-images.gumlet.io/icons/app-store.png",
      "alt": "Download app on apple app store"
    }
  })])])]) : _vm._e(), _vm._v(" "), (!_vm.hideFooter) ? _c('footer', {
    class: _vm.overlayBottomPaddingVisible ? 'overlayBottomPadding' : ''
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.shopNow) ? _c('div', {
    staticClass: "col-6 col-md-3 col-xs-6"
  }, [_c('div', {
    staticClass: "footerlinks"
  }, [_c('h5', {
    staticClass: "fred"
  }, [_vm._v("SHOP FOR")]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.formattedshopNow)
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-3 col-xs-6"
  }, [_c('div', {
    staticClass: "footerlinks"
  }, [_c('h5', {
    staticClass: "fred"
  }, [_vm._v("NEED HELP")]), _vm._v(" "), _c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/contact-us"
    }
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.appFooterEventHandler('Contact Us')
      }
    }
  }, [_vm._v("Contact Us")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/orders"
    }
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.appFooterEventHandler('Track Order')
      }
    }
  }, [_vm._v("Track Order")])])], 1), _vm._v(" "), (_vm.isSelectedCountryIndia) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/faqs"
    }
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.appFooterEventHandler('Returns & Refunds')
      }
    }
  }, [_vm._v("Returns & Refunds")])])], 1) : _vm._e(), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/faqs"
    }
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.appFooterEventHandler('FAQs')
      }
    }
  }, [_vm._v("FAQs")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/profile"
    }
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.appFooterEventHandler('My Account')
      }
    }
  }, [_vm._v("My Account")])])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-3 col-xs-6"
  }, [_c('div', {
    staticClass: "footerlinks"
  }, [_c('h5', {
    staticClass: "fred"
  }, [_vm._v("COMPANY")]), _vm._v(" "), _c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/about-us"
    }
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.appFooterEventHandler('About Us')
      }
    }
  }, [_vm._v("About Us")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/investor-relation"
    }
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.appFooterEventHandler('Investor Relation')
      }
    }
  }, [_vm._v("Investor Relation")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/careers"
    }
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.appFooterEventHandler('Careers')
      }
    }
  }, [_vm._v("Careers")])])], 1), _vm._v(" "), (!_vm.showNewStoreNearMe) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/stores-near-me"
    }
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.appFooterEventHandler('Stores Near Me')
      }
    }
  }, [_vm._v("Stores Near Me")])])], 1) : _vm._e(), _vm._v(" "), (_vm.bannerPlaceHolderForGiftVoucher && _vm.isSelectedCountryIndia) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/gift-voucher"
    }
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.appFooterEventHandler('Gift Vouchers')
      }
    }
  }, [_vm._v("Gift Vouchers")])])], 1) : _vm._e(), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/from-the-soul"
    }
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.appFooterEventHandler('From The Soul')
      }
    }
  }, [_vm._v("Community Initiatives")])])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-md-3 col-xs-6"
  }, [_c('div', {
    staticClass: "footerlinks"
  }, [_c('h5', {
    staticClass: "fred"
  }, [_vm._v("MORE INFO")]), _vm._v(" "), _c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/terms-and-conditions"
    }
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.appFooterEventHandler('T&C')
      }
    }
  }, [_vm._v("T&C")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/privacy-policy"
    }
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.appFooterEventHandler('Privacy Policy')
      }
    }
  }, [_vm._v("Privacy Policy")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/sitemap"
    }
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.appFooterEventHandler('Sitemap')
      }
    }
  }, [_vm._v("Sitemap")])])], 1), _vm._v(" "), (_vm.bannerPlaceHolderForGetNotified) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/getnotified"
    }
  }, [_c('span', [_vm._v(" Get Notified")])])], 1) : _vm._e(), _vm._v(" "), (_vm.bannerPlaceHolderForBlog && _vm.bannerPlaceHolderForBlog.description) ? _c('li', [_c('a', {
    attrs: {
      "href": _vm.bannerPlaceHolderForBlog && _vm.bannerPlaceHolderForBlog.description,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.appFooterEventHandler('Blog')
      }
    }
  }, [_vm._v(_vm._s(_vm.bannerPlaceHolderForBlog.tag_text || 'Blog'))])])]) : _vm._e()])])]), _vm._v(" "), (_vm.showNewStoreNearMe && _vm.isSelectedCountryIndia) ? _c('div', {
    staticClass: "col-6 col-md-3 col-xs-6"
  }, [_c('div', {
    staticClass: "footerlinks"
  }, [_c('h5', {
    staticClass: "fred"
  }, [_vm._v("STORE NEAR ME")]), _vm._v(" "), _c('ul', _vm._l((_vm.storeListDetails), function(store) {
    return _c('li', {
      key: store.id,
      on: {
        "click": function($event) {
          _vm.appFooterEventHandler(store.city)
        }
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: '/stores-near-me',
          hash: ((store.city) + "-" + (store.id))
        }
      }
    }, [_c('a', {
      attrs: {
        "href": ("#" + (store.city))
      }
    }, [_c('span', [_vm._v(" " + _vm._s(store.city) + " ")])])])], 1)
  })), _vm._v(" "), (_vm.storeDetails.length > 4) ? _c('button', {
    staticClass: "stores-btn",
    on: {
      "click": _vm.toggleView
    }
  }, [_vm._v("\n                     " + _vm._s(_vm.isExpanded ? 'View Less' : 'View More') + "\n                  ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.shopNow && _vm.$parent.isDesktop) ? _c('div', {
    staticClass: "col-12"
  }, [(_vm.isSelectedCountryIndia) ? _c('div', {
    staticClass: "footerlinks notAnimate cod"
  }, [_vm._m(1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.$parent.isDesktop && _vm.shopNow) ? _c('div', {
    staticClass: "col-6 col-md-3 col-xs-6"
  }, [(_vm.isSelectedCountryIndia) ? _c('div', {
    staticClass: "footerlinks notAnimate"
  }, [_vm._m(2)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.shopNow) ? _c('div', {
    staticClass: "col-6 col-md-3 col-xs-6"
  }, [(_vm.isSelectedCountryIndia) ? _c('div', {
    staticClass: "footerlinks notAnimate"
  }, [_vm._m(3)]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.$parent.isDesktop && !_vm.isBflUtm && _vm.isSelectedCountryIndia) ? _c('div', {
    staticClass: "row justify-content-center align-content-center my-3"
  }, [_c('div', [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [_c('a', {
    staticClass: "mr-3",
    attrs: {
      "href": "https://play.google.com/store/apps/details?id=com.thesouledstore"
    },
    on: {
      "click": function($event) {
        _vm.triggerEvent('Play Store')
      }
    }
  }, [_c('img', {
    staticClass: "app-store-logo",
    attrs: {
      "data-src": "https://tss-static-images.gumlet.io/icons/play-store.png",
      "alt": "Download app on google play store"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://apps.apple.com/in/app/thesouledstore/id1493897434"
    },
    on: {
      "click": function($event) {
        _vm.triggerEvent('App Store')
      }
    }
  }, [_c('img', {
    staticClass: "app-store-logo",
    attrs: {
      "data-src": "https://tss-static-images.gumlet.io/icons/app-store.png",
      "alt": "Download app on apple app store"
    }
  })])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "footersocial"
  }, [_c('div', {
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v("Follow Us:   ")]), _vm._v(" "), _c('div', {
    staticClass: "inlineEl pt20"
  }, [_c('follows-withsocial', {
    attrs: {
      "sizeicon": "small",
      "showtitle": false,
      "callerComp": 'footer'
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('hr', {
    staticClass: "divider d10 showinmobile"
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "borderbox"
  }, [_c('div', {
    staticClass: "footeraccordian",
    attrs: {
      "id": "footAccord",
      "role": "tablist",
      "aria-multiselectable": "true"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "collapse pb-3 px-3",
    attrs: {
      "id": "footAccordOne",
      "role": "tabpanel",
      "aria-labelledby": "headingOne"
    }
  }, _vm._l((_vm.populerSearchData), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "navi"
    }, [_c('div', {
      staticClass: "brand-cover text-uppercase d-block"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _vm._l((item.categories), function(cat, catIndex) {
      return _c('div', {
        key: catIndex
      }, [(cat.url_key) ? _c('router-link', {
        attrs: {
          "to": cat.url_key
        }
      }, [_c('span', {
        on: {
          "click": function($event) {
            _vm.appFooterEventHandler(cat.name, ((item.name) + " > " + (cat.name)))
          }
        }
      }, [_vm._v(_vm._s(cat.name))])]) : _vm._e(), _vm._v(" "), _vm._l(((cat && cat.sub_categories)), function(sub, subCatIndex) {
        return _c('div', {
          key: subCatIndex
        }, [(sub.url_key) ? _c('router-link', {
          attrs: {
            "to": sub.url_key
          }
        }, [_c('span', {
          on: {
            "click": function($event) {
              _vm.appFooterEventHandler(sub.name, ((item.name) + " > " + (cat.name) + " > " + (sub.name)))
            }
          }
        }, [_vm._v(_vm._s(sub.name))])]) : _vm._e()], 1)
      })], 2)
    })], 2)
  }))]), _vm._v(" "), (!(_vm.$route.path == '/checkout' || _vm.$route.path == '/delivery-address' || _vm.$route.path == '/cart' || ((_vm.$route.path).startsWith('/product')))) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header",
    attrs: {
      "role": "tab",
      "id": "headingTwo"
    }
  }, [_c('h5', {
    staticClass: "mb-0 accordianheading fred mt-0 text-uppercase"
  }, [_c('a', {
    staticClass: "collapsed",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#footAccord",
      "href": "#footAccordTwo",
      "aria-expanded": "false",
      "aria-controls": "footAccordTwo"
    }
  }, [(_vm.footerTextTitle) ? _c('h2', {
    staticClass: "custom-font-size"
  }, [_vm._v(" About "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.formattedArtist)
    }
  })]) : (_vm.$route.params.artname) ? _c('h2', {
    staticClass: "custom-font-size"
  }, [_vm._v("Artist Information")]) : (_vm.$route.name === 'membership') ? _c('h2', {
    staticClass: "custom-font-size"
  }, [_vm._v("The Souled Store Membership")]) : _c('h2', {
    staticClass: "custom-font-size"
  }, [_vm._v("Who we are")])])])]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "footAccordTwo",
      "role": "tabpanel",
      "aria-labelledby": "headingTwo"
    }
  }, [_c('div', {
    staticClass: "card-block col-md-8"
  }, [_c('div', {
    staticClass: "navigationbox d-block text-justify",
    attrs: {
      "id": "about-product"
    }
  }, [(_vm.$route.name === 'membership') ? _c('div', [_vm._v("\n                      We, at The Souled Store, aim to give you something you'll love, something you can use to express yourself, and, simply put, something to put a smile on your face. We know you love our collection of awesome t-shirts, notebooks, boxer shorts, mobile covers, socks, mugs, pins, flip-flops, badges, stickers, backpacks, and everything else. So we decided to reward your loyalty with a little token of our appreciation- The Souled Store Membership. "), _c('br'), _c('br'), _vm._v("\n                      Our yearly membership offers you all your favourite products at massive discounts, free shipping, prioritised delivery, and early access. The perks are so good, we aren't sure why we didn't launch this earlier!"), _c('br'), _c('br')]) : (_vm.footerText) ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.formattedFooterText)
    }
  }) : _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.defaultFooterText)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('p', {
    staticClass: "text-uppercase",
    staticStyle: {
      "text-decoration": "underline"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.formattedArtist && _vm.formattedArtist.length ? (_vm.formattedArtist + " PRICE LIST") : '')
    }
  }), _vm._v(" "), (_vm.allProducts) ? _c('table', {
    staticClass: "table",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', {
    staticClass: "font-weight-bold"
  }, [_c('td', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.formattedArtist)
    }
  })])]), _vm._v(" "), _vm._l((_vm.allProducts), function(prm, index) {
    return _c('tr', {
      key: prm.id || Math.random()
    }, [(index < 10 && !prm.tiptiles) ? [_c('td', [_c('router-link', {
      attrs: {
        "to": 'product/' + prm.product_slug
      }
    }, [_vm._v(_vm._s(prm.product))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(prm.price && _vm.getround(prm.price)))])] : _vm._e()], 2)
  })], 2)]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (((_vm.$route.path).startsWith('/product')) && _vm.formattedFooterTextArtist) ? _c('div', {
    staticClass: "card"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "footAccordThree",
      "role": "tabpanel",
      "aria-labelledby": "headingThree"
    }
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "navigationbox",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "text-justify",
    domProps: {
      "innerHTML": _vm._s(_vm.formattedFooterTextArtist)
    }
  })])])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('hr', {
    staticClass: "divider d10 showmobile"
  }), _vm._v(" "), (_vm.isSelectedCountryIndia) ? _c('div', {
    staticClass: "container mob_mtb0 footerIcon"
  }, [_c('div', {
    staticClass: "row mbrow"
  }, [_c('div', {
    staticClass: "col-md-6 col-12 d-md-flex align-items-center"
  }, [_c('div', {
    staticClass: "dinline"
  }, [_vm._v("100% Secure Payment: " + _vm._s(_vm.$route.queries))]), _vm._v(" "), _vm._m(7)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-12 shipping-partners d-md-flex align-items-center"
  }, [_c('div', {
    staticClass: "iconsdivider"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {}, [_vm._v("Shipping Partners:")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-center ship-footer-icon"
  }, _vm._l((_vm.shippingPartners), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "dinline payment-tile"
    }, [_c('img', {
      staticClass: "payopt",
      attrs: {
        "data-src": item.imgPath,
        "alt": item.imgAlt,
        "width": "55",
        "height": "29"
      }
    })])
  }))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), (this.$route.path != '/' && _vm.currentCat != 'winterwear-collection' && _vm.currentCat != 'membership') ? _c('div', {
    staticClass: "popsearch_section"
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.populerSearchNew.length > 0) ? _c('div', {
    staticClass: "popsearch01"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "popsr_cont"
  }, [_vm._l((_vm.populerSearchNew), function(item, i) {
    return _c('div', {
      key: i
    }, [(item.url) ? _c('div', {
      class: ("populer pop_" + i)
    }, [_c('router-link', {
      attrs: {
        "to": item.url
      }
    }, [_c('span', {
      on: {
        "click": function($event) {
          _vm.appFooterEventHandler(item.name, ("Popular Searches > " + (item.name)))
        }
      }
    }, [_vm._v(_vm._s(item.name))])])], 1) : _vm._e()])
  }), _vm._v(" "), (_vm.popularSearch) ? _c('div', {
    staticClass: "populer-extra",
    domProps: {
      "innerHTML": _vm._s(_vm.formattedpopularSearch)
    }
  }) : _vm._e()], 2)]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "text-center mb0"
  }, [_c('span', {
    staticClass: "fsemibold"
  }, [_c('i', {
    staticClass: "fa fa-copyright"
  }), _vm._v(" "), (this.$route.path === '/') ? _c('h1', {
    staticClass: "footer-h1"
  }, [_vm._v(" The Souled Store ")]) : _c('span', [_vm._v("The Souled Store ")]), _vm._v("\n            " + _vm._s(_vm.currentYear) + "-" + _vm._s((_vm.currentYear + 1).toString().substr(2, 2)) + "\n          ")])])]) : _vm._e()]), _vm._v(" "), ((_vm.isComboActive && _vm.bannerPlaceHolderForMenWomenMsite && !_vm.$parent.isDesktop && !_vm.bannerPlaceHolderForGoForAppOnlySale) && (this.$route.path === '/men' || this.$route.path === '/kids' || this.$route.path === '/women' || this.$route.path === '/categories' || this.$route.path === '/mywishlist' || this.$route.path === '/my-account' || this.$route.path === '/membership')) ? _c('div', {
    staticClass: "mbstickyfooter mt20"
  }, [_c('div', {
    staticClass: "row justify-content-md-center"
  }, [_c('div', {
    staticClass: "col-md-12   col"
  }, [_c('ul', {
    staticClass: "foot_menu"
  }, [_c('li', {
    on: {
      "click": function($event) {
        _vm.footerMenu('/home')
      }
    }
  }, [_c('router-link', {
    staticClass: "toggle-menu",
    attrs: {
      "aria-label": "Home",
      "to": _vm.webcategory ? '/' + _vm.webcategory : '/'
    }
  }, [_c('img', {
    attrs: {
      "alt": "home",
      "data-src": (this.activeFooterTab != 'categories' && (this.activeFooterTab === 'home' || this.$route.path === '/men' || this.$route.path === '/kids' || this.$route.path === '/women')) ? 'https://prod-img.thesouledstore.com/public/theSoul/images/icons/home.png' : 'https://stag-img.thesouledstore.com/public/theSoul/images/icons/home_black.png'
    }
  })])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.footerMenu('/mywishlist')
      }
    }
  }, [_c('img', {
    attrs: {
      "alt": "wishlist",
      "data-src": this.$route.path === '/mywishlist' && this.activeFooterTab === '' ? 'https://prod-img.thesouledstore.com/public/theSoul/images/icons/wishlist_red.png' : 'https://prod-img.thesouledstore.com/public/theSoul/images/icons/wishlist.png'
    }
  })]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.footerMenu('/categories')
      }
    }
  }, [_c('img', {
    attrs: {
      "alt": "categories",
      "data-src": this.$route.path === '/categories' ? 'https://prod-img.thesouledstore.com/public/theSoul/images/icons/category_red.png' : 'https://prod-img.thesouledstore.com/public/theSoul/images/icons/category.png'
    }
  })]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.footerMenu('/membership')
      }
    }
  }, [_c('div', [_c('img', {
    staticClass: "footer-exclusive-icon",
    attrs: {
      "alt": "membership",
      "data-src": this.$route.path === '/membership' && this.activeFooterTab === '' ? 'https://prod-img.thesouledstore.com/public/theSoul/images/crown-red.png' : 'https://prod-img.thesouledstore.com/public/theSoul/images/crown.png'
    }
  }), _c('div', {
    staticClass: "footer-exclusive-icon-text",
    class: {
      'color-red': this.$route.path === '/membership' && this.activeFooterTab === ''
    }
  }, [_vm._v(_vm._s(_vm.setMenuTextExclusive))])])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.footerMenu('/my-account')
      }
    }
  }, [_c('img', {
    attrs: {
      "alt": "account",
      "data-src": this.$route.path === '/my-account' && this.activeFooterTab === '' ? 'https://prod-img.thesouledstore.com/public/theSoul/images/icons/profile_red.png' : 'https://prod-img.thesouledstore.com/public/theSoul/images/icons/profile.png'
    }
  })])])])])]) : _vm._e()])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-uppercase text-center"
  }, [_c('div', {
    staticClass: "app-download-header",
    staticStyle: {
      "color": "black"
    }
  }, [_c('b', [_c('i', {
    staticClass: "fa fa-mobile mr-1",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" experience the souled store app")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {}, [_c('li', [_c('span', [_c('i', {
    staticClass: " circleicon_light fa fa-rupee"
  }), _vm._v(" COD Available")])]), _vm._v(" "), _c('li', {
    staticClass: "showdesktop"
  }, [_c('span', [_c('i', {
    staticClass: "circleicon_light fa fa-refresh"
  }), _vm._v(" 30 Days Easy Returns")])]), _vm._v(" "), _c('li')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {}, [_c('li', [_c('span', [_c('i', {
    staticClass: " circleicon_light fa fa-rupee"
  }), _vm._v(" COD Available")])]), _vm._v(" "), _c('li', {
    staticClass: "showdesktop"
  }, [_c('span', [_c('i', {
    staticClass: "circleicon_light fa fa-refresh"
  }), _vm._v(" 30 Days Easy Returns")])]), _vm._v(" "), _c('li')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {}, [_c('li', [_c('span', [_c('i', {
    staticClass: " circleicon_light fa fa-rupee"
  }), _vm._v(" COD Available")])]), _vm._v(" "), _c('li', [_c('span', [_c('i', {
    staticClass: "circleicon_light fa fa-refresh"
  }), _vm._v(" 30 Days Easy Returns")])]), _vm._v(" "), _c('li')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-uppercase"
  }, [_c('div', {
    staticClass: "app-download-header"
  }, [_c('b', [_c('i', {
    staticClass: "fa fa-mobile mr-1",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" experience the souled store app")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header",
    attrs: {
      "role": "tab",
      "id": "headingOne"
    }
  }, [_c('h5', {
    staticClass: "mb-0 accordianheading fred mt-0"
  }, [_c('a', {
    staticClass: "custom-font-size",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#footAccord",
      "href": "#footAccordOne",
      "aria-expanded": "false",
      "aria-controls": "footAccordOne"
    }
  }, [_vm._v("\n                    NAVIGATION LINKS\n                    ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header",
    attrs: {
      "role": "tab",
      "id": "headingThree"
    }
  }, [_c('h5', {
    staticClass: "mb-0 accordianheading fred mt-0"
  }, [_c('a', {
    staticClass: "collapsed",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#footAccord",
      "href": "#footAccordThree",
      "aria-expanded": "false",
      "aria-controls": "footAccordThree"
    }
  }, [_c('span', [_vm._v("ARITIST'S DETAILS")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "parentdinline payment payment-wrapper"
  }, [_c('div', {
    staticClass: "dinline payment-tile phonepay"
  }), _vm._v(" "), _c('div', {
    staticClass: "dinline payment-tile gpay"
  }), _vm._v(" "), _c('div', {
    staticClass: "dinline payment-tile amazonpay"
  }), _vm._v(" "), _c('div', {
    staticClass: "dinline payment-tile mastercard"
  }), _vm._v(" "), _c('div', {
    staticClass: "dinline payment-tile mobikwik"
  }), _vm._v(" "), _c('div', {
    staticClass: "dinline payment-tile paytm"
  }), _vm._v(" "), _c('div', {
    staticClass: "dinline payment-tile credpay"
  }), _vm._v(" "), _c('div', {
    staticClass: "dinline payment-tile cod"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title012"
  }, [_c('h2', [_vm._v("POPULAR SEARCHES")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3610fc48"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/AppFooter.vue
// module id = 2451
// module chunks = 49